export default {
  "inventoryLog.title": "在庫調整ログ",
  "inventoryLog.searchPlaceHolder": "検索（ログID、取引番号、商品名など）",
  "inventoryLog.sun": "日",
  "inventoryLog.mon": "月",
  "inventoryLog.tue": "火",
  "inventoryLog.wed": "水",
  "inventoryLog.thu": "木",
  "inventoryLog.fri": "金",
  "inventoryLog.sat": "土",
  "inventoryLog.concession": "コンセクション",
  "inventoryLog.commercial": "物販",
  "inventoryLog.ingredient": "材料",
  "inventoryLog.getGoods": "入荷",
  "inventoryLog.sellGoods": "販売",
  "inventoryLog.refoundGoods": "返送",
  "inventoryLog.discardGoods": "廃棄",
  "inventoryLog.otherGoods": "その他",
  "inventoryLog.refoundGoodsFromCustomer": "返品",
  "inventoryLog.SALES_ITEM": "買取",
  "inventoryLog.CONSIGNMENT": "委託",
  "inventoryLog.inventoryLogId": "ログID",
  "inventoryLog.createTime": "日時",
  "inventoryLog.actualDate": "処理日付",
  "inventoryLog.inventoryType": "販売分類",
  "inventoryLog.groupName": "分類",
  "inventoryLog.productCode": "商品コード",
  "inventoryLog.name": "商品名",
  "inventoryLog.productType": "販売形態",
  "inventoryLog.unit": "単位",
  "inventoryLog.stockPlace": "在庫場所",
  "inventoryLog.inventoryChangeType": "種類",
  "inventoryLog.stockQtyChanged": "在庫数（変動後）",
  "inventoryLog.stockChangeQty": "変動数",
  "inventoryLog.stockQty": "在庫数（変動前）",
  "inventoryLog.stockPrice": "在庫単価",
  "inventoryLog.stockAmountChanged": "在庫金額（変動後）",
  "inventoryLog.stockChangeAmount": "在庫金額変動",
  "inventoryLog.stockAmount": "在庫金額（変動前）",
  "inventoryLog.changePeople": "デバイス/担当者",
  "inventoryLog.inventoryChangeSupplement": "備考",
};